import { Component, OnInit } from '@angular/core'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { CURRENT_STATUS, QUERY_ID, QUERY_NAME, DESCRIPTION, RAISED_ON } from 'src/app/constants/ui.columns'
import { QueriesAPIModel, StatusCountAPIModel } from 'src/app/models/api.model'
import { ViewForSelectionComponent } from '../../common/view-for-selection/view-for-selection.component'
import { QueryService } from 'src/app/services/query/query.service'
import { COMPLETED, IN_PROGRESS, QUERIES_RECEIVED } from 'src/app/constants/stats-cards'

@Component({
  selector: 'app-query-dashboard',
  templateUrl: './query-dashboard.component.html',
  styleUrls: ['./query-dashboard.component.scss']
})
export class QueryDashboardComponent implements OnInit {
  readonly routingLink = `/${GlobalConstants.ROUTING.QUERY}/{0}/${GlobalConstants.ROUTING.DETAILS}`
  readonly QUERY_SUMMARY_LINK = `/${GlobalConstants.ROUTING.QUERY}/${GlobalConstants.ROUTING.SUMMARY}`

  itemsList: QueriesAPIModel[] = []
  statusCountMap: StatusCountAPIModel[] = []
  itemsTableColumns = [QUERY_ID, QUERY_NAME, RAISED_ON, CURRENT_STATUS]
  statsCards = [QUERIES_RECEIVED, IN_PROGRESS, COMPLETED]

  constructor(private queryService: QueryService) {}

  ngOnInit(): void {
    this.queryService.dispatchFetchQueryDashboardDataAction(
      ViewForSelectionComponent.defaultValue,
      GlobalConstants.SORT_COLUMN.CREATED_DATETIME,
      null
    )

    this.queryService.getQueryDashboardInfo().subscribe((queryDashboardInfo) => {
      if (queryDashboardInfo) {
        this.itemsList = queryDashboardInfo?.queriesItemsList?.content
        this.statusCountMap = queryDashboardInfo?.statusCountMap
      }
    })
  }

  handleViewForData($event: any) {
    this.queryService.dispatchFetchQueryDashboardDataAction($event, 'createdDatetime', null)
  }
}
